// 由 EB view/admin/src/router/modules/promoter.js 自动转换
// +----------------------------------------------------------------------
// | EB [ EB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016-2026 https://www.eb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed EB并不是自由软件，未经许可不能去掉EB相关版权
// +----------------------------------------------------------------------
// | Author: EB Team <admin@eb.com>
// +----------------------------------------------------------------------
import Layout from '@/layout/index.vue';
import type { RouteRecordRaw } from 'vue-router'
import { roterPre } from '@/setting';
const promoterRouter: RouteRecordRaw =
  {
    path: `${roterPre}/promoter`,
    name: 'promoter',
    meta: {
      icon: '',
      title: '设置'
    },
    alwaysShow: true,
    component: Layout,
    children: [
      {
        path: 'config',
        name: 'PromoterConfig',
        meta: {
          title: '分销配置',
          noCache: true
        },
        component: () => import('@/views/promoter/config/index.vue')
      },
      {
        path: 'user',
        name: 'AccountsUser',
        meta: {
          title: '分销员列表',
          noCache: true
        },
        component: () => import('@/views/promoter/user/index.vue')
      },
      {
        path: 'orderList',
        name: 'PromoterOrderList',
        meta: {
          title: '分销订单',
          noCache: true
        },
        component: () => import('@/views/promoter/order/index.vue')
      },
      {
        path: 'bank/:id?',
        name: 'PromoterBank',
        meta: {
          title: '页面设置',
          noCache: true
        },
        component: () => import('@/views/system/groupData/data.vue')
      },
      {
        path: 'commission',
        name: 'commissionDes',
        meta: {
          title: '佣金说明',
          noCache: true
        },
        component: () => import('@/views/promoter/commission/index.vue')
      },
      {
        path: 'gift',
        name: 'AccountsGift',
        meta: {
          title: '分销礼包',
          noCache: true
        },
        component: () => import('@/views/promoter/gift/index.vue')
      },
      {
        path: 'membership_level',
        name: 'PromoterLevel',
        meta: {
          title: '分销等级',
          noCache: true
        },
        component: () => import('@/views/promoter/membershipLevel/index.vue')
      },
      {
        path: 'distribution',
        name: 'distributionRules',
        meta: {
          title: '分销等级规则',
          noCache: true
        },
        component: () => import('@/views/promoter/distributionRules/index.vue')
      },
      {
        path: 'retail',
        name: 'distributionRetail',
        meta: {
          title: '分销说明',
          noCache: true
        },
        component: () => import('@/views/promoter/distributionRetail/index.vue')
      }

    ]
  }

export default promoterRouter;
